import { changeActivitySelectRetention as changeActivitySelectRetentionDiagram, selectActivityFilterGridData } from '@process-advisor/process-miner/processMiner/processMiner';

export type ActivitySelectRetentionProps = {
    mode?: string;
}

export const changeActivitySelectRetention = ({
    mode,
}: ActivitySelectRetentionProps) => {
    changeActivitySelectRetentionDiagram({ mode });
    selectActivityFilterGridData('');
};
